_ = require 'underscore'

class BooleanExpression
  constructor: (attr) ->
    @attr = attr
    @bool = undefined

  toggle: ->
    @bool = !@bool

  getValue: ->
    @bool

  hasValue: ->
    @bool?

  update: (value) ->
    @bool = value

  clear: ->
    @bool = undefined

  toStr:  ->
    return "" unless @bool?
    "#{ @attr } eq #{ @bool }"

class UnionExpression
  constructor: (attr) ->
    @attr = attr
    @values = []

  update: (value) ->
    @values.push(value)

  getValue: ->
    @values

  hasValue: ->
    @values.length > 0

  clearOne: (value) ->
    index = @values.indexOf(value)
    return unless index != -1
    @values.splice(index, 1)

  clear: ->
    @values = []

  toggle: (value) ->
    if value in @values
      @clearOne(value)
    else
      @update(value)

  toStr:  ->
    _.map @values, (value) =>
      "#{ @attr } eq \"#{ value }\""
    .join(" or ")

class TextSearchExpression
  constructor: (searchFields) ->
    @searchFields = searchFields
    @term = ""

  update: (term) ->
    @term = term

  getValue: ->
    @term

  hasValue: ->
    @term != ""

  clear: ->
    @term = ""

  toggle: ->
    throw new Error("Can't toggle a TextSearchExpression.")

  toStr:  ->
    return "" unless @term

    fields = _.chain(@searchFields)
      .filter (searchField) =>
        !searchField.useIfTermMatches? || searchField.useIfTermMatches(@term)
      .pluck('fieldName')
      .value()

    _.map fields, (field) =>
      "#{ field } co \"#{ @term }\""
    .join(" or ")

module.exports.FilterStringBuilder = class FilterStringBuilder

  constructor: (searchFields) ->
    @expressions = {
      search: new TextSearchExpression(searchFields)
      members: new UnionExpression("members.value")
      teams: new UnionExpression("organizations.id")
      userType: new UnionExpression("userType")
      hasTransferred: new BooleanExpression("ownedByEnterprise")
    }

  update: (name, value) ->
    @expressions[name].update(value)

  clearAll: ->
    for name in _.keys(@expressions)
      @clear(name)

  clear: (name) ->
    @expressions[name].clear()

  toggle: (name, value) ->
    @expressions[name].toggle(value)

  toString: ->
    _.reduce _.values(@expressions), (memo, expression) ->
        str = expression.toStr()
        memo.push("(#{ str })") if str
        memo
      , []
    .join(" and ")

  getState: ->
    _.mapObject @expressions, (expression) ->
      expression.getValue()

  getActiveFilters: ->
    _.filter _.keys(@expressions), (name) =>
      @expressions[name].hasValue()

  getQuery: ->
    filter: @toString()

# For lists that don't use SCIM-style filters and only have a single unified
# search field (currently just Join Requests and Public Boards).
# SimpleFilterStringBuilder maintains interface consistency but returns the
# single search term as the only filter value.
module.exports.SimpleFilterStringBuilder = class SimpleFilterStringBuilder extends FilterStringBuilder

  getQuery: ->
    query = { search: @expressions.search.getValue() }
    if @expressions.teams.getValue().length
      query = _.extend(query, { idOrganizations: @expressions.teams.getValue() })
    query



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/filter-string-builder.coffee